export const LOCAL_STORAGE_KEYS = {
  DEXIE_SYNC_CHECK_LAST_UPDATED: 'dexieSyncCheckLastUpdated',
};
